// extracted by mini-css-extract-plugin
export default {"CreateProfilePage":"CreateOrEditProfilePage_CreateProfilePage__OonY7"};